import { onLogin, apolloClient } from '@/vue-apollo.js';
import { mutation } from '@/core/methods/mutation.js';
import { adoptUserLocale } from '@/utils/language-service';

const userSignIn = (phone, password) => {
	let auth;
	let variables = {
		phone: phone,
		password: password
	};

	let mutationPath = 'user/api/signin';
	auth = mutation(variables, mutationPath)
		.then((data) => {
			return setUserAndToken(apolloClient, data);
		})
		.catch((error) => {
			// console.log(error.message.toString());

			return JSON.stringify(error.message);

		});
	return auth;
};

// set role & user & token
function setUserAndToken(apolloClient, data) {
	onLogin(apolloClient, data.data.userSignIn.token);
	const user = data.data.userSignIn.user;
	if (typeof localStorage !== 'undefined') {
		localStorage.setItem('DONE_USER', JSON.stringify(user));
		localStorage.setItem('DONE_USER_ROLE', user.role);
		localStorage.setItem('DONE_USER_PERMISSIONS', data.data.userSignIn.permissions);
		if (data.data.userSignIn.userRoles) {
			let permissions = JSON.stringify(data.data.userSignIn.userRoles);
			localStorage.setItem('DONE_USER_ROLE_PERMISSIONS', permissions);
		}
	}

	// Language is a per-user preference held on the user record, so it follows
	// the user onto whichever browser they sign in from. Applying it here is
	// enough: the navbar and every page mount fresh on the way to the dashboard,
	// and App.vue keys its view tree on the locale.
	adoptUserLocale(user);

	return true;
}

export { userSignIn };
